type Props = {
  nome: string;
  tagUrl?: string | null;
  qrCodePath?: string | null;
};

export default function PetTagBox({ nome, tagUrl, qrCodePath }: Props) {
  const qrUrl = qrCodePath
    ? qrCodePath.startsWith("http")
      ? qrCodePath
      : qrCodePath.startsWith("/storage/")
      ? qrCodePath
      : `/storage/${qrCodePath}`
    : null;

  if (!tagUrl && !qrUrl) return null;

  async function copiar() {
    if (!tagUrl) return;

    try {
      await navigator.clipboard.writeText(tagUrl);
      alert("Link copiado!");
    } catch {
      alert("Não foi possível copiar o link.");
    }
  }

  return (
    <div className="bg-card rounded-xl card-shadow mt-6 overflow-hidden">
      <div className="gradient-primary px-6 py-4">
        <h2 className="text-lg font-bold text-primary-foreground">
          TAG de Identificação
        </h2>
      </div>

      <div className="p-6 text-center">
        {qrUrl && (
          <img
            src={qrUrl}
            alt={`QR ${nome}`}
            className="mx-auto mb-4 max-w-[200px] bg-white p-2 rounded"
          />
        )}

        {tagUrl && (
          <input
            value={tagUrl}
            readOnly
            className="w-full border rounded px-3 py-2 mb-3 text-sm"
          />
        )}

        <div className="flex flex-col md:flex-row gap-2 justify-center">
          {qrUrl && (
            <a
              href={qrUrl}
              download
              className="px-4 py-2 border rounded"
            >
              Baixar QR
            </a>
          )}

          {tagUrl && (
            <a
              href={tagUrl}
              target="_blank"
              rel="noreferrer"
              className="px-4 py-2 border rounded"
            >
              Abrir página
            </a>
          )}

          {tagUrl && (
            <button
              type="button"
              onClick={copiar}
              className="px-4 py-2 bg-primary text-white rounded"
            >
              Copiar link
            </button>
          )}
        </div>
      </div>
    </div>
  );
}